import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Routes, Route } from 'react-router-dom';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import GroupFeatureRelationList from '~users/components/group-feature-relation-list-fc';
import FormBasedEditor from '~common/form/form-based-editor';
import * as request from 'superagent';
import {setValueAtPath} from '~common/form/helper';
import URLManager from '~common/lib/url-manager';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import { APIError } from '~common/lib/types';

import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import FormBasedContainer from "~common/form/form-based-container-fc";
import {ContainerTypeEditor} from "~common/form/form-based-container-fc";


const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
}

type State = {
	status: "loading" | "ready"
	data: any;
	form: any;
	definitions: Array<any>;
	error?: any;
};

class PortalGroupEditor extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			status: "ready",
			data: {},
			form: {},
			definitions: []
		};
	}

	componentDidMount() {

	}

	UNSAFE_componentWillReceiveProps() {
		
	}

	render() {

    	const {match} = this.props;
		const { classes }: { classes: ClassNameMap } = this.props;
		var {status} = this.state

		switch(status) {
			case "loading":
				return <LoadingView classes={{}} />;
			case "ready":
				return (
					<div className={classes.container}>
						<AppView history={this.props.history}>
							<DefinitionDataProvider>
								<FormBasedContainer
									containerType={ContainerTypeEditor} 
									history={this.props.history} 
									match={match}
									dataUrl="/api/portal-groups"
									formSelector={{"form": "portalGroupEditor", "module": "users", "userType": "Internal"}}
									successMessage="Portal Group Successfully Saved"
									customRenderers={{
										"GroupFeatureRelationList": GroupFeatureRelationList
									}}
									allowDelete={this.props.match.params.id !== "new"}
									confirmDeleteMessage={"Are you sure you want to delete this group?"}
									returnURL={`/groups/admin?q=${URLManager.getQueryStringValue(URLManager.getQueryString(window.location.href))}`}
								>
								</FormBasedContainer>
							</DefinitionDataProvider>
					</AppView>
					</div>
				);
		}

		
	}
}

export default withStyles(styles)(PortalGroupEditor);
